import { Card, CardContent, Stack } from "@altimateai/lego";
import type { Granularity } from "./ClusterCostTrends";
import ClusterCostTrends from "./ClusterCostTrends";
import ClusterList from "./ClusterList";

interface ComputeTabPanelProps {
  filterPortalId: string;
  savedFiltersPortalId: string;
  granularity: Granularity;
  days: number;
  onGranularityChange: (value: string) => void;
}

const ComputeTabPanel = ({
  filterPortalId,
  savedFiltersPortalId,
  granularity,
  days,
  onGranularityChange,
}: ComputeTabPanelProps) => (
  <Card className="al-mt-4">
    <CardContent className="al-pt-6">
      <Stack direction="column" gap="xl">
        <ClusterCostTrends granularity={granularity} onGranularityChange={onGranularityChange} />
        <ClusterList
          days={days}
          filterPortalId={filterPortalId}
          savedFiltersPortalId={savedFiltersPortalId}
        />
      </Stack>
    </CardContent>
  </Card>
);

export default ComputeTabPanel;
